import styles from "./index.module.scss";
// import MainTitle from "@/components/MainTitle";
import TitleWhithLine from "@/components/TitleWhithLine";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { news_list } from "@/apis/news";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import WOW from "wowjs";
import "animate.css/animate.min.css";
const Latest = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const goToDetail = (id, link) => {
    if (link) {
      window.open(link, "_blank");
    } else {
      navigate(`/detail?id=${id}&type=NEWS`);
    }
  };
  const getList = () => {
    news_list({
      pageSize: 6,
      currentPage: 1,
      status: 1,
    })
      .then((res) => {
        const arr = res.data.records.map((item) => {
          return {
            id: item.newsUuid,
            type: item.newsType,
            title: item.title,
            des: item.text,
            date: item.phenomenonTime,
            link: item.link,
            imgPath: item.cover?.filePath,
          };
        });
        setList(arr);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    if (list.length > 0) {
      // 数据加载完成后初始化 WOW.js
      const wow = new WOW.WOW({
        live: false, // 不自动检测新元素
        offset: 30,
      });
      wow.init();
      return () => {
        // 清理操作，这里暂时不需要特别的清理
      };
    }
  }, [list]);
  useEffect(() => {
    getList();
  }, []);

  return (
    <div className={styles.latestBox}>
      <div className="container">
        <div className="wow animate__fadeInUp" data-wow-duration={`1s`}>
          <h1>{intl.get("Home.News and Information")}</h1>
          <div className="flex_box flex_center">
            <TitleWhithLine
              title="Home.More"
              style={{ textAlign: "center" }}
              link="/community/news"
            />
          </div>
        </div>
        <Row gutter={40} style={{ marginTop: "60px" }}>
          {list.slice(0, 3).map((item, index) => {
            return (
              <Col
                span={8}
                key={item.id}
                onClick={() => goToDetail(item.id, item.link)}
                className="wow animate__fadeInUp"
                data-wow-duration={`${index * 0.5}s`}
              >
                <div>
                  <div
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_API_AFFIX}/file/preview?filePath=${item?.imgPath})`,
                      backgroundSize: "100% 100%",
                      height: "200px",
                    }}
                  ></div>
                  {/* <img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + item.imgPath} /> */}
                  <div className={styles.label}>{item.type}</div>
                  <div className={styles.titles}>
                    <h2 title={item.title}>{item.title}</h2>
                    <p title={item.des}>{item.des}</p>
                    <p className={styles.date}>{item.date}</p>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
        <Row gutter={40} style={{ marginTop: "40px" }}>
          {list.slice(3, 6).map((item, index) => {
            return (
              <Col
                span={8}
                key={item.id}
                onClick={() => goToDetail(item.id, item.link)}
                className="wow animate__fadeInUp"
                data-wow-duration={`${index * 0.5}s`}
              >
                <div>
                  <div
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_API_AFFIX}/file/preview?filePath=${item?.imgPath})`,
                      backgroundSize: "100% 100%",
                      height: "200px",
                    }}
                  ></div>
                  {/* <img src={process.env.REACT_APP_API_AFFIX+"/file/preview?filePath=" + item.imgPath} /> */}
                  <div className={styles.label}>{item.type}</div>
                  <div className={styles.titles}>
                    <h2 title={item.title}>{item.title}</h2>
                    <p title={item.des}>{item.des}</p>
                    <p className={styles.date}>{item.date}</p>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};
export default Latest;
